<template>
  <hl-Modal
    v-if="show"
    :title="`Oppgrader abonnement for ${tenantName}`"
    class="text-center"
    iconClass="budicon-business-area text-primary"
    dismisable
    @close="$emit('update:show', false)"
  >
    <p>
      Oppgradering til Premium sørger for at du får et tryggere utleieforhold med {{ tenantName }}. Du får juridisk
      bistand (opp til 1t/år) og utleieforsikring som dekker opp til 6 mnd ubetalt leie og boligskade.
    </p>

    <p>
      Vennligst les og bekreft vilkårene for å oppgradere til Premium-abonnementet til {{ newPrice | toCurrency }} per
      mnd.
    </p>

    <p>
      Det kreves et depositum som tilsvarer minimum tre måneders husleie for at utleieforsikringen i
      Premium-abonnementet skal være gyldig.
    </p>

    <div class="pt-5 px-5 d-flex">
      <hl-Checkbox v-model="acceptTerms">
        Jeg har lest og akseptert
        <a href="https://www.husleie.no/juridisk/abonnementsvilkar" target="_blank">Husleie.no sine abonnementsvilkår</a
        >.
      </hl-Checkbox>
    </div>

    <div class="mt-5">
      <hl-Button
        class="mx-2"
        :disabled="upgrading || !acceptTerms"
        :loading="upgrading"
        @click="$emit('click:upgrade')"
      >
        Oppgrader
      </hl-Button>
      <hl-Button class="mx-2" variant="secondary" outline @click="$emit('update:show', false)">{{
        translationCancel
      }}</hl-Button>
    </div>
  </hl-Modal>
</template>

<script>
import Button from '@modules/husleie-framework/src/components/buttons/Button.vue';
import Checkbox from '@modules/husleie-framework/src/components/forms/inputs/checkbox/Checkbox';
import Modal from '@modules/husleie-framework/src/components/modals/Modal.vue';
import i18nCommon from '@modules/i18n/mixins/Common';

export default {
  name: 'UpgradeSubscriptionModal',
  mixins: [i18nCommon],
  components: {
    'hl-Modal': Modal,
    'hl-Button': Button,
    'hl-Checkbox': Checkbox,
  },

  props: {
    show: Boolean,
    tenantName: String,
    newPrice: Number,
    upgrading: Boolean,
  },

  data() {
    return {
      acceptTerms: false,
    };
  },
  computed: {
    translationCancel() {
      return this.translate('cancel');
    },
  },
};
</script>
